import JjxmFybxd from '../jjxmFybxd'
import JJFKSQD from '../jjFksqd'
import oaFybxd from '../oaFybxd'
import jksqd from '../jksqd'
import fksqd from '../fksqd'
import saleBill from '../saleBill'
import saleFybxd from '../saleFybxd'
import publicBuill from '../js/publicBuill'
export default {
  name: 'BillTableTemplate',
  components: {
    JjxmFybxd,
    jksqd,
    fksqd,
    JJFKSQD,
    oaFybxd,
    saleBill,
    saleFybxd
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    tableData: Array,
    // eslint-disable-next-line vue/require-default-prop
    sumArr: Array,
    // eslint-disable-next-line vue/require-default-prop
    billName: String,
    // eslint-disable-next-line vue/prop-name-casing,vue/require-default-prop
    BtnArr: Array,
    // eslint-disable-next-line vue/require-default-prop
    pageConfig: Object,
    saleEdit: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    billType: Array
  },
  data() {
    return {
      billTemplate: {
        rowData: {},
        company: '',
        view: 'view',
        AccountingReview: false,
        jjxmFybxdShow: false,
        oaFybxdShow: false,
        jksqdShow: false,
        fksqdShow: false,
        jjFksqdShow: false,
        saleBillShow: false,
        saleFybxdShow: false,
        invoiceShow: false
      },
      tableLabel: [
        {
          label: '申请日期',
          prop: 'rq',
          width: '135'
        },
        {
          label: '单据号',
          prop: 'billCode',
          width: '110',
          search: '',
          aligin: 'left'
        },
        {
          label: '单据类别',
          prop: 'billType',
          width: '130',
          aligin: 'left'
        },
        {
          label: '借款人或供应商',
          prop: 'borrower',
          width: '250',
          aligin: 'left'
        },
        {
          label: '申请付款金额',
          prop: 'sqje',
          width: '120',
          aligin: 'right'
        },
        {
          label: '审批金额',
          prop: 'tgje',
          width: '120',
          aligin: 'right'
        },
        {
          label: '付款用途',
          prop: 'purpose',
          width: '220',
          aligin: 'left'
        },
        {
          label: '业务公司',
          prop: 'companyName',
          width: '220',
          aligin: 'left'
        }
      ],
      roles: '',
      input: '',
      jkr: '',
      tableHeight: '0px',
      functionsToBePaidTotalShow: false,
      zt: '全部',
      tableIndex: -1
    }
  },
  mounted() {
  },
  updated() {
    this.$nextTick(() => {
      this.$refs['billTable'].doLayout()
    })
  },
  created() {
    if (this.billName === 'billToDo') {
      this.tableHeight = '200px'
    } else if (this.billName === 'toBePaid') {
      this.tableHeight = '185px'
    } else {
      this.tableHeight = '255px'
    }
    if (this.billName === 'paid') {
      this.tableLabel.unshift(
        {
          label: '付款日期',
          prop: 'cnqrrq',
          width: '135'
        })
    }
    this.roles = this.billType ? this.billType[0].value : ''
  },
  methods: {
    Nindex(index) {
      const page = this.pageConfig.currentPage
      const pageSize = this.pageConfig.pageSize
      return index + 1 + (page - 1) * pageSize
    },
    async bindEditClick(row, view) {
      const loading = this.$loading({
        lock: true,
        text: '查询中,请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const djh = row.billCode.substring(0, 2)
      this.billTemplate.rowData = await publicBuill.findBillDataByBillCode(row.billCode, row.lrr)
      this.billTemplate.view = view
      if (view === 'AccountingReview') {
        this.billTemplate.view = 'edit'
        this.billTemplate.AccountingReview = true
      }
      if (view === 'examine' && (this.saleEdit || row.accountingReview === '1') && row.flowId) {
        this.billTemplate.AccountingReview = true
      }
      if (djh === 'FY') {
        this.billTemplate.oaFybxdShow = true
      } else if (djh === 'JJ' || djh === 'ZJ') {
        this.billTemplate.jjxmFybxdShow = true
      } else if (djh === 'JK') {
        this.billTemplate.jksqdShow = true
      } else if (djh === 'FK') {
        this.billTemplate.fksqdShow = true
      } else if (djh === 'JM' || djh === 'JN' || djh === 'ZM' || djh === 'ZN') {
        this.billTemplate.jjFksqdShow = true
      } else if (djh === 'CB') {
        this.billTemplate.saleBillShow = true
      } else if (djh === 'FB') {
        this.billTemplate.saleFybxdShow = true
      }
      loading.close()
    },
    //绑定删除操作
    bindDeleteClick(row) {
      const value = row.billCode
      const data = { djh: value }
      let url = ''
      if (value.indexOf('FY') !== -1) { // 费用报销单
        url = '/fesback/fybxd/deleteFybxdByDJH.z'
      } else if (value.indexOf('JK') !== -1) { //借款申请单
        url = '/fesback/loadForm/deleteJKSQDByDJH.z'
      } else if (value.indexOf('FK') !== -1) { // 付款申请单
        url = '/fesback/fksqd/deleteFKSQDByDJH.z'
      } else if (value.indexOf('JM') !== -1) { // 基建项目付款申请单
        url = '/fesback/fksqdJm/deleteFKSQDJMByDJH.z'
      } else if (value.indexOf('JN') !== -1) { //基建项目设备付款申请单
        url = '/fesback/fksqdJn/deleteFKSQDJnByDJH.z'
      } else if (value.indexOf('ZM') !== -1) { // 锻造产业园基建项目付款申请单
        url = '/fesback/fksqdJmDz/deleteFKSQDJMDzByDJH.z'
      } else if (value.indexOf('ZN') !== -1) { //锻造产业园基建项目设备付款申请单
        url = '/fesback/fksqdJnDz/deleteFKSQDJndzByDJH.z'
      } else if (value.indexOf('JJ') !== -1) { // 基建项目费用报销单
        url = '/fesback/fybxdJm/deleteFybxdJMByDJH.z'
      } else if (value.indexOf('ZJ') !== -1) { //铸锻产业园基建费用费用报销单
        url = '/fesback/fybxdDm/deleteFybxdDMByDJH.z'
      }
      this.$confirm('确认删除单据号：' + value + ' 单据数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在删除单据信息...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        publicBuill.deleteInvoice(data)
        this.$post(url, data).then(response => {
          if (response.success === true) {
            this.$message.success(response.message)
            this.$emit('queryBillData')
          } else {
            this.$message.error(response.message)
          }
          loading.close()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val)
    },
    handleCurrentChange(val) {
      this.$emit('handleCurrentChange', val)
    },
    bindSearch() {
      this.$emit('findBillDataByBillCode', { roles: this.roles, billCode: this.input, jkr: this.jkr, zt: this.zt })
    },
    exportMyApplication() {
      this.$emit('exportMyApplication', { roles: this.roles, billCode: this.input, jkr: this.jkr, zt: this.zt, state: this.pageConfig.status })
    },
    print(row) {
      publicBuill.print(row)
      row.dycs = parseInt(row.dycs) + 1
    },
    /* 确认支付 */
    confirmPayment(row) {
      this.$confirm('你确认要进行申请单付款确认吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          billCode: row.billCode,
          borrower: localStorage.userName,
          flowId: row.flowId
        }
        this.$post('/fesback/billData/confirmPayment.z', data).then(response => {
          if (response.success) {
            this.$message({
              type: 'success',
              message: '确认支付成功!'
            })
            this.$emit('confirmPayment')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认支付'
        })
      })
    },
    queryBillData() {
      this.$emit('queryBillData')
    },
    stateClass(row, prop) {
      const state = row.state
      if (((state === '2' || state === '3') && (prop === 'billCode' || prop === 'tgje')) || prop === 'returned') {
        if (state === '1') {
          return ''
        } else if (state === '2') {
          return 'state2'
        } else if (state === '3')
          return 'state3'
      }
      return ''
    },
    voidedBill(row) {
      const h = this.$createElement
      this.$prompt(
        h('p', null, [h('i', { style: 'color: red' }, '* '),
          h('span', null, '请输入作废原因：')]),
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValidator: (value) => {
            if (!value || value.trim() === '') return '请输入作废原因。。'
          }
        }).then(({ value }) => {
        this.$confirm('你确认要将' + row.billCode + '单据作废吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const data = {
            voidedBillCode: row.billCode,
            voidedUser: localStorage.getItem('userName'),
            voidedUserNo: localStorage.getItem('userNo'),
            voidedBz: value
          }
          this.$post('/fesback/voided/voidedBill.z', data).then(res => {
            if (res.success) {
              this.$message.success(res.message)
              this.$emit('queryBillData')
            } else {
              this.$message.error(res.message)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消单据作废'
          })
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    getSummaries(param) {
      return this.sumArr
    },
    showZfMethod(row) {
      this.tableIndex = row.index
    },
    invoiceVerification(row) {
      console.log(row)
      this.billTemplate.rowData = row
      this.billTemplate.invoiceShow = true
    }
  }
}
